module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "ptb-100",
    attrs: {
      "id": "about"
    }
  }, [(_vm.content && _vm.content.length) ? _c('div', {
    staticClass: "container"
  }, [_c('el-breadcrumb', {
    staticStyle: {
      "font-size": "18px",
      "margin-bottom": "80px",
      "margin-top": "-60px"
    },
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("物流工具")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })], 1) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "height": "800px"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading",
    staticStyle: {
      "color": "#409EFF",
      "font-size": "80px",
      "position": "relative",
      "left": "40%"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47d0bcea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Page.vue
// module id = 720
// module chunks = 1